(function () {
var $68e423cf84b1a2ac$exports = {};
const $68e423cf84b1a2ac$var$getParentNodes = (node, path)=>{
    path = path || [];
    const { parentNode: parentNode } = node;
    if (!parentNode) return path;
    return $68e423cf84b1a2ac$var$getParentNodes(parentNode, path.concat(parentNode));
};
const $68e423cf84b1a2ac$var$getEventPath = (event)=>{
    if (event.path) return event.path;
    if (event.composedPath) return event.composedPath();
    return $68e423cf84b1a2ac$var$getParentNodes(event.target);
};
window.onload = ()=>{
    const docs = [
        ...document.querySelectorAll(".docs-names .doc-name")
    ];
    const activeDoc = docs.find((doc)=>location.href.includes(doc.getAttribute("href").replace(".html", "")));
    const select = document.querySelector(".docs-select");
    const docsContainer = document.querySelector(".docs-names");
    activeDoc.classList.add("active");
    select.querySelector(".selected-doc").innerHTML = activeDoc.innerText;
    document.querySelector(".docs-select").onclick = ()=>docsContainer.classList.toggle("opened");
    window.onclick = (event)=>{
        const path = $68e423cf84b1a2ac$var$getEventPath(event);
        const isOutsideClick = !path.includes(document.querySelector(".links-wrapper"));
        if (isOutsideClick) docsContainer.classList.remove("opened");
    };
};

})();
//# sourceMappingURL=gdpr.2da47e27.js.map
